<template>
  <Dialog :open="showModal" @update:open="showModal = $event">
    <DialogTrigger as-child>
      <button type="button" class="btn btn-light text-danger border text-nowrap">
        {{ $t('Change URL') }}
      </button>
    </DialogTrigger>
    <DialogScrollContent>
      <DialogHeader>
        <DialogTitle>{{ $t('Change the event URL') }}</DialogTitle>
      </DialogHeader>
      <div class="tw:my-4">
        <label for="slug" class="form-label">{{ $t('New URL') }}</label>
        <input
          id="slug"
          v-model="slug"
          class="form-control"
          required
          pattern="[a-z0-9]+(?:-[a-z0-9]+)*"
        >
      </div>
      <DialogFooter>
        <Button type="button" variant="secondary" @click="showModal = false">
          {{ $t('Cancel') }}
        </Button>
        <form :action="action" method="post">
          <input type="hidden" name="_token" :value="csrfToken">
          <input type="hidden" name="_method" value="PUT">
          <input type="hidden" name="slug" :value="slug">
          <Button type="submit" variant="destructive">
            {{ $t('Update slug') }}
          </Button>
        </form>
      </DialogFooter>
    </DialogScrollContent>
  </Dialog>
</template>

<script setup>
import { ref, computed } from 'vue'
import { Dialog, DialogScrollContent, DialogTrigger, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog'
import { Button } from '@/shadcn/components/ui/button/index.js'

const props = defineProps({
  action: {
    type: String,
    required: true,
  },
  currentSlug: {
    type: String,
    required: true,
  },
})

const showModal = ref(false)
const slug = ref(props.currentSlug)

const csrfToken = computed(() => window.Laravel.csrfToken)
</script>
